import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';



import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";


import Select from 'react-select';




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const UpdateAttendanceList = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        company: '',
        user_id:"ALL",

    })



	

	
	const history = useHistory();
	const [submitted, setSubmitted] = useState(false);
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
	const [addattnlist, setaddattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();

	const [selectedDateValue, setSelectedDateValue] = useState('');
    const [selectedEmpValue, setSelectedEmpValue] = useState('');

    const handelInput = (event) => {
        // event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.in_time.toLowerCase()}${item.out_time.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

		const startIndex = (currentPage - 1) * entriesPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		// const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	const clearInput = () => {
		setSearchTerm("");
	  };





      const handleEmployees = async () => {
	  
        	axios.get(API_BASE_URL + '/all_regular_employees', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
   
         .then(res1 => setdataval(res1.data))
         .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleEmployees();
      }, []);



	 



const handleSubmit = async (e) => {
    e.preventDefault();

	if (loading) {
		return;
	}

	setSubmitted(true);
	setLoading(true);

	// alert(user.start_date);
	// alert(user.department);



    try {
      const response = await axios.post(API_BASE_URL +'/update_attendance_list',
		{ attendance_date: user.start_date, employee_id: user.user_id }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
// console.log(response.data.update_attendance_list);

     setSelectedDateValue(user.user_id);
	 setSelectedEmpValue(user.start_date);
      setRecords(response.data.update_attendance_list); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };


  




	

	const emptyUser={
	search_emp_id: '',
	shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
	}



const [modalData, setModalData] = useState({
    shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
});

const handelModalInput = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
};

	const handleUpdate = async (user_id,attn_date,search_emp_id) => {

		// console.log(user_id);
		// console.log(attn_date);
		const depart_id=0;

		

		axios.get(API_BASE_URL + '/read_shift_data/' + user_id +'/'+attn_date+'/'+depart_id+'/'+search_emp_id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			
             
			.then(res => {
     console.log(res.data.readshift);  // data is here
    setModalData(res.data.readshift); // set modal fields
    setattnlist(res.data.readshift.attn_list); // set attendance list
  })
			 
			.catch(err => console.log(err))
	};


	const handleAdd = async (user_id,attn_date) => {

		// console.log(user_id);
		// console.log(attn_date);

		axios.get(API_BASE_URL + '/add_attendance_list/' + user_id +'/'+attn_date, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			
   
			 .then(res1 => setModalData(res1.data.add_attendance_list[0]))
			//  .then(res2=>setaddattnlist(res2.data.add_attendance_list))
			 
			.catch(err => console.log(err))
	};

		const handleDecision = async (action, attendance_id) => {

		
	const confirmMessage =
		action === "delete"
			? "Are you sure you want to delete this attendance?"
			: "Are you sure you want to delete this attendance?";

	if (!window.confirm(confirmMessage)) return;

	const endpoint =
		action === "delete" ? "/deleteAttendance" : "/deleteAttendance";

		

	try {
		const response = await axios.get(API_BASE_URL + endpoint+'/'+attendance_id+'/'+action, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});

		if (response.data.status === "success") {
			
			toast.success(response.data.message, {
						 position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
						style: {
							backgroundColor: "#28a745", // ✅ Bootstrap Success Green
							color: "#fff",              // White text
							fontWeight: "500"
						},
						});
			setTimeout(() => {
      window.location.href = "/updateattendancelist";
    }, 1500);
		} else {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				theme: "colored",
			});
			setTimeout(() => {
      window.location.href = "/updateattendancelist";
    }, 1500);
		}
	} catch (error) {
		toast.error(error.response?.data?.message || "An error occurred", {
			position: "bottom-right",
			autoClose: 5000,
			theme: "colored",
		});
	}
};


		const handleEditSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		// alert(modalData.search_emp_id);
		axios.post(API_BASE_URL + '/update_attendance', {shift_date : modalData.attendance_date, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				window.$("#attendanceModal").modal("hide");

    // Reload attendance based on updated date
    reloadAttendance(modalData.shift_date,modalData.search_emp_id);

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const reloadAttendance = async (searchdate, search_emp_id) => {
  try {
    const response = await axios.post(
      API_BASE_URL + '/update_attendance_list',
      {
        attendance_date: searchdate,
        employee_id: search_emp_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    // These lines depend on your logic — adjust as needed:
    setSelectedDateValue(searchdate);
    setSelectedEmpValue(search_emp_id);

    setRecords(response.data.update_attendance_list);

  } catch (error) {
    console.error("Error loading attendance:", error);
  }
};


	const handleAddSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/add_attendance', {shift_date : modalData.attendance_date, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};

	

const filteredOptions =  user.company === "0"
  ? dataval                                 // company NOT selected → show all employees
  : dataval.filter(emp => emp.company_id == user.company); 


const options = [
  { value: "ALL", label: "All Employee" },
  ...filteredOptions.map(option => ({
    value: option.user_id,
    label: `${option.first_name} ${option.last_name} ${option.employee_id}`
  }))
];



const columns = [
  { label: "In Time", key: "in_time", sortable: true },
  { label: "Out Time", key: "out_time", sortable: true },
  { label: "Total Work", key: "total_work", sortable: true }
];



	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
												<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
											</svg>
											Update Attendance
										</h3>
									</div>
									<div className="card-body">
										 <form onSubmit={handleSubmit}>

                                            <div class="row align-items-end">

											<div className="col-md-3 col-sm-6">
												<div className="form-group mb-2">
												<label>Date</label>
												{/* <input type="date" className="form-control" name="start_date" value={user.start_date}
								onChange={handelInput} placeholder="Start Date" /> */}

												<DatePicker
													selected={user.start_date ? new Date(user.start_date) : null}
													onChange={(date) => {
													const value = date
													? date.toISOString().split("T")[0] // YYYY-MM-DD
													: "";
													setUser(prev => ({
													...prev,
													start_date: value,
													}));
													}}
													dateFormat="dd-MM-yyyy"
													placeholderText="Select Start Date"
													className="form-control"
													wrapperClassName="w-100"
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
													/>

												</div>
											</div>



                                            <div className="col-md-3 col-sm-12">
															<div className="form-group mb-2">
															<label>Company</label>

															<select className="form-control show-tick" name="company"  isSearchable={true} // Enable search
														 value={user.company}  onChange={handelInput} style={{ height: "38px" }}>
															<option value="ALL">Select Company</option>
															<option value="0">Annai Arul Hospital</option>
														</select>

															</div>
														</div>





                                    <div className="col-md-3 col-sm-6">
									<div className="form-group mb-2">
									<label>Employee</label>
										<Select
  name="user_id"
  options={options}
  isSearchable={true}
  placeholder="Select Employee"
  value={options.find(opt => opt.value === user.user_id) || null}
  onChange={(selected) =>
  handelInput({
    target: {
      name: "user_id",
      value: selected?.value || ""
    }
  })
}

  styles={{
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "38px",
    borderRadius: "4px",
    borderColor: "#ced4da",
    boxShadow: "none",
    fontSize: "14px",
    padding: "0 4px",
    "&:hover": { borderColor: "#b3b3b3" }
  }),

  valueContainer: (base) => ({
    ...base,
    height: "38px",
    padding: "0 6px",
  }),

  input: (base) => ({
    ...base,
    margin: "0px",
    padding: "0px"
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "38px"
  }),

  menu: (base) => ({
    ...base,
    borderRadius: "4px",
    zIndex: 9999
  }),

  option: (base, state) => ({
    ...base,
    fontSize: "12px",
    padding: "6px 10px",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
    color: "#333"
  })
}}
classNamePrefix="react-select"
/>

										
								 {/* <select className="form-control show-tick" name="user_id"  isSearchable={true} onChange={handelInput} // Enable search
														 value={user.user_id}>
										<option value="ALL">All Employee</option>
										 {user.company == '0' && (
										<>
										{dataval.map(option => (
										<option key={option.user_id} value={option.user_id}>
										{option.first_name} {option.last_name} {option.employee_id}
										</option>
										))}

										</>
										 )}
									</select> */}
									</div>
                                    </div>







                                <div className="col-md-3 col-sm-6">
									<div className="form-group mb-2">

                                <button type="submit" className="btn btn-primary" disabled={loading}>
								{loading ? "Loading..." : "GET"}
							</button>

							

							
                            </div>
                            </div>



                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>




<div className="modal fade" id="attendanceModal" tabIndex="-1" role="dialog" aria-hidden="true">




  <form onSubmit={handleEditSubmit}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" style={{ width: '650px'}}>
        <div className="modal-header">
          <h5 className="modal-title">Edit Attendance for {modalData.full_name}</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="row clearfix">
            {/* <div className="col-md-6">
              <div className="form-group">
               
										<label className="form-label">Shift Code<span className="form-required">*</span></label>
										<select className="form-control show-tick" name="shift_code" value={modalData.shift_code} onChange={handelModalInput} >
										<option value="">Select Shift Code</option>
											{officeshift.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
											{option.shift_name}
											</option>
											))}
									</select>
									
									</div>
            </div> */}
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-label">Shift Date</label>
                {/* <input type="date" className="form-control" name="attendance_date" value={modalData.attendance_date} onChange={handelModalInput} /> */}
				<DatePicker
												  selected={modalData.attendance_date ? new Date(modalData.attendance_date) : null}
												  onChange={(date) => {
													const value = date
													  ? date.toISOString().split("T")[0] // YYYY-MM-DD
													  : "";
												
													setModalData(prev => ({
													  ...prev,
													  attendance_date: value,
													}));
												  }}
												  dateFormat="dd-MM-yyyy"
												  placeholderText="Select Attendance Date"
												  className="form-control"
												  showMonthDropdown
												  showYearDropdown
												  dropdownMode="select"
												/>
			  </div>
            </div>
           

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock In Date<span className="form-required">*</span></label>
                {/* <input type="date" className="form-control" name="clock_in_date" value={modalData.clock_in_date} onChange={handelModalInput} /> */}
				<DatePicker
																  selected={modalData.clock_in_date ? new Date(modalData.clock_in_date) : null}
																  onChange={(date) => {
																	const value = date
																	  ? date.toISOString().split("T")[0] // YYYY-MM-DD
																	  : "";
																
																	setModalData(prev => ({
																	  ...prev,
																	  clock_in_date: value,
																	}));
																  }}
																  dateFormat="dd-MM-yyyy"
																  placeholderText="Select ClockIn Date"
																  className="form-control"
																  showMonthDropdown
																  showYearDropdown
																  dropdownMode="select"
																/>
			  </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">In Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_in" value={modalData.clock_in} onChange={handelModalInput} />
              </div>
            </div>

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock In Date<span className="form-required">*</span></label>
                {/* <input type="date" className="form-control" name="clock_out_date" value={modalData.clock_out_date} onChange={handelModalInput} /> */}
				<DatePicker
																  selected={modalData.clock_out_date ? new Date(modalData.clock_out_date) : null}
																  onChange={(date) => {
																	const value = date
																	  ? date.toISOString().split("T")[0] // YYYY-MM-DD
																	  : "";
																
																	setModalData(prev => ({
																	  ...prev,
																	  clock_out_date: value,
																	}));
																  }}
																  dateFormat="dd-MM-yyyy"
																  placeholderText="Select ClockOut Date"
																  className="form-control"
																  showMonthDropdown
																  showYearDropdown
																  dropdownMode="select"
																/>
			  </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">Out Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_out" value={modalData.clock_out} onChange={handelModalInput} />
              </div>
            </div>



			<div class="col-md-12">
            <div class="form-group">
             

                <textarea cols="50" rows="5" name="attendance_history" value={modalData.attendance_history} hidden/>
                <input name="old_clock_in_date" type="hidden" value={modalData.clock_in_date} />

                  <input  name="old_clock_in" type="hidden" value={modalData.clock_in} />

                   <input  name="old_clock_out_date" type="hidden" value={modalData.clock_out_date} />

                <input name="old_clock_out" type="hidden" value={modalData.clock_out} />

                <input name="old_shift_code" type="hidden" value={modalData.shift_code} />

				<input name="search_emp_id" type="hidden" value={modalData.search_emp_id} />
				<input name="employee_id" type="hidden" value={modalData.employee_id} />
				<input name="user_id" type="hidden" value={modalData.user_id} />
            
            </div>
          </div>
           
          </div>
        </div>


        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" className="btn btn-primary">Update</button>
        </div>

		




      </div>
    </div>
  </form>
</div>




<div className="modal fade" id="attendanceModalAdd" tabIndex="-1" role="dialog" aria-hidden="true">




  <form onSubmit={handleAddSubmit}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" style={{ width: '650px'}}>
        <div className="modal-header">
          <h5 className="modal-title">Attendance for {modalData.full_name}</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="row clearfix">
            {/* <div className="col-md-6">
              <div className="form-group">
               
										<label className="form-label">Shift Code<span className="form-required">*</span></label>
										<select className="form-control show-tick" name="shift_code" value={modalData.shift_code} onChange={handelModalInput} >
										<option value="">Select Shift Code</option>
											{officeshift.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
											{option.shift_name}
											</option>
											))}
									</select>
									
									</div>
            </div> */}
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-label">Shift Date</label>
                <input type="date" className="form-control" name="attendance_date" value={modalData.attendance_date} onChange={handelModalInput} />
              </div>
            </div>
           

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock In Date<span className="form-required">*</span></label>
                <input type="date" className="form-control" name="clock_in_date" value={modalData.clock_in_date} onChange={handelModalInput} />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">In Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_in" value={modalData.clock_in} onChange={handelModalInput} />
              </div>
            </div>

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock In Date<span className="form-required">*</span></label>
                <input type="date" className="form-control" name="clock_out_date" value={modalData.clock_out_date} onChange={handelModalInput} />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">Out Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_out" value={modalData.clock_out} onChange={handelModalInput} />
              </div>
            </div>



			<div class="col-md-12">
            <div class="form-group">
             

                <textarea cols="50" rows="5" name="attendance_history" value={modalData.attendance_history} hidden/>
                <input name="old_clock_in_date" type="hidden" value={modalData.clock_in_date} />

                  <input  name="old_clock_in" type="hidden" value={modalData.clock_in} />

                   <input  name="old_clock_out_date" type="hidden" value={modalData.clock_out_date} />

                <input name="old_clock_out" type="hidden" value={modalData.clock_out} />

                <input name="old_shift_code" type="hidden" value={modalData.shift_code} />


				<input name="employee_id" type="hidden" value={modalData.employee_id} />
				<input name="user_id" type="hidden" value={modalData.user_id} />
            
            </div>
          </div>
           
          </div>
        </div>


        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" className="btn btn-primary">Update</button>
        </div>

		




      </div>
    </div>
  </form>
</div>





					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

                                      {submitted && records.length === 0 && (

										<div className="form-footer text-right">
                                                                   <button
																		type="button" onClick={() =>{ handleAdd(selectedEmpValue,selectedDateValue);setModalData(emptyUser)}}
																		className="btn btn-primary" style={{ marginRight: '30px', paddingRight: '0.5rem' }}
																		data-toggle="modal"
																		data-target="#attendanceModalAdd"
																		>Add {selectedEmpValue.user_id}</button>
																		</div>
																	
																	
      )}
                                         

										<div className="card-header">
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive sticky-table-wrap">
		

    
      
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
													<thead>
														<tr>
                                                            <th>Action</th>
                                                           {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default" }}
      >
        {col.label}
        {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
      </th>
    ))}
															
															
														</tr>
													</thead>
													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

															

															return(
															<tr key={record.employee_id}>
																<td>
                                                            
																	<button
																		type="button" onClick={() =>{ handleUpdate(record.user_id,record.attn_date,record.search_emp_id);setModalData(emptyUser)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#attendanceModal"
																		>
																	<i className="fa fa-edit" />
																	</button>   <button
                                                                                        className="btn btn-primary"
                                                                                         onClick={() => handleDecision("delete", record.time_attendance_id)}
                                                                                    >
                                                                                        <i class='fas fa-trash-alt'></i>
                                                                                    </button>
																	
															
                                                                </td>
                                                                <td>{record.in_time}</td>
																<td>{record.out_time}</td>
                                                                <td>{record.total_work}</td>
															
															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="4" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(UpdateAttendanceList);